import { getEventTypeShortCodeForEvent } from "@/constants/eventTypes";
import { formatDateTime } from "@/utils/dateFormat";

/**
 * Build a select-option label for event pickers.
 */
export function formatEventSelectLabel(event) {
  const typeCode = getEventTypeShortCodeForEvent(event);
  const startLabel = event.eventStartTime ? formatDateTime(event.eventStartTime) : "No date";
  return `[${typeCode}] ${event.name} — ${startLabel}`;
}
